<template>
  <div 
    v-if="visivel"
    class="w3-modal" 
    style="display: block;"
    id="modalPesquisarOrcamento">
    
    <div class="w3-modal-content w3-animate-zoom"> 
      <header class="w3-container" style="padding:0px!important">
        <span 
          @click="visivel = false" 
          class="w3-button w3-display-topright" 
          id="close_modal_produtos">&times;
        </span>
        <h4 v-if="somenteUltimosPedidosVendedor == 'N'" class="titulo texto-vermelho">Pesquisa de Orçamentos</h4>
        <h4 v-if="somenteUltimosPedidosVendedor == 'S'" class="titulo texto-vermelho">Últimos 15 pedidos</h4>
      </header>

      <exibir-processando v-if="processando"/>

      <div class="w3-col l6 m12" style="margin-bottom: 15px;" v-if="somenteUltimosPedidosVendedor == 'S'">
        <legenda>
          <span>Nome do vendedor</span>
          <i slot="referencia" class="fa fa-user-tie texto-vermelho"></i>
        </legenda>
        <label data-label="resultado-venda" id="eResultado">&nbsp;{{nome_vendedor}}</label>

        <div style="margin-top: 10px;">
          <input 
            type="text"
            class="input-pesquisa"
            onclick="this.select()"
            id="txtPesquisaCliente"
            placeholder="Buscar cliente" 
            v-on:keyup="pesquisarPorNomeCliente()"
          />
          <button 
            title="Limpar chave de pesquisa"
            class="botao-pesquisa"
            v-on:click="limparPesquisaPorNomeCliente()">
            <i class="fa fa-times"/>
          </button>
        </div>
      </div>
      
      <div 
        style="padding:0px"
        class="w3-margin-bottom"
        v-show="mostrar_filtros_orcamento && (somenteUltimosPedidosVendedor == 'N')">
        
        <div class="w3-col m2 s12">
          <label>Orçamento</label>
            <input 
              type="number"
              id="chave_orcamento"
              ref="chave_orcamento"
              onFocus="this.select()"
              onClick="this.select()"
              class="w3-input w3-border"  
              v-model="pesquisa_orcamento_orcamento_id" 
              v-on:keyup.enter="buscarOrcamento()"
            />
        </div>
        
        <div class="w3-col m6 s12">
          <label>Nome do cliente</label>
          <input 
            type="text"
            onFocus="this.select()"
            onClick="this.select()"
            class="w3-input w3-border" 
            style="text-transform:uppercase"  
            v-model="pesquisa_orcamento_nome_cliente" 
            v-on:keyup.enter="buscarOrcamento()"
          />
        </div>
          
        <div class="w3-col m4 s12">
          <label>Tipo de pessoa</label>
          <select class="w3-select w3-border" v-model="pesquisa_orcamento_tipo_pessoa">
            <option value="">Todos</option>
            <option value="F">Física</option>
            <option value="J">Jurídica</option>
          </select>
        </div>
              
        <div class="w3-col m6 s12 w3-margin-top" v-show="pesquisa_orcamento_tipo_pessoa == 'J'">
          <label>CNPJ</label>
          <input 
            type="text" 
            class="w3-input w3-border" 
            v-model="pesquisa_orcamento_cnpj" 
            v-mask="'##.###.###/####-##'"
          />
        </div>              
              
        <div class="w3-col m12 s12 l12 w3-margin-top"  v-show="pesquisa_orcamento_tipo_pessoa != 'J'">
          <label>CPF</label>
          <input 
            type="text" 
            onFocus="this.select()"
            onClick="this.select()"
            class="w3-input w3-border" 
            v-model="pesquisa_orcamento_cpf" 
            :disabled="pesquisa_orcamento_tipo_pessoa == ''" 
            v-mask="'###.###.###-##'"
          />
        </div>       
            
        <div class="w3-col m12 s12 l12 w3-margin-top">
          <div class="w3-row"><span>Data de cadastro</span></div>              
          <div class="w3-col s10 m4 l4 w3-center">                  
            <input 
              class="w3-input w3-border" 
              type="date" 
              onFocus="this.select()"
              onClick="this.select()"
              maxlength="10" 
              placeholder="Dia/Mês/Ano"
              v-model="pesquisa_orcamento_data_cadastro_inicial" 
              onkeyup="FormataDataDiaMesAno(this,'##/##/####',event)"
            />
          </div>

          <div class="w3-col s2 m1 l1 w3-center">   
            <button
              v-on:click="aplicarDataAtual('data_inicial')"
              class="w3-button">
              <i class="fas fa-calendar-alt"/>
            </button>
          </div>                       
            
          <div class="w3-col s12 m2 l2 w3-center">
            <span style="display: inline-block; margin-top: 10px;">até</span>
          </div>
                
          <div class="w3-col s10 m4 l4">                  
            <input 
              class="w3-input w3-border" 
              type="date" 
              onFocus="this.select()"
              onClick="this.select()"
              maxlength="10" 
              placeholder="Dia/Mês/Ano"
              v-model="pesquisa_orcamento_data_cadastro_final" 
              onkeyup="FormataDataDiaMesAno(this,'##/##/####',event)"
            />
          </div>   

          <div class="w3-col s2 m1 l1 w3-center">   
            <button
              v-on:click="aplicarDataAtual('data_final')"
              class="w3-button">
              <i class="fas fa-calendar-alt"/>
            </button>
          </div>                            
        </div>
          
        <div class="w3-col s5 m5 l5 w3-margin-top">
          <label>Vendedor</label>
          <select class="w3-select w3-border" v-model="pesquisa_orcamento_tipo_vendedor">
            <option value="ID">Código</option>
            <option value="NO">Nome</option>
          </select>    
        </div>  
          
        <div class="w3-col s6 m6 l6 w3-margin-top w3-margin-left">      
          <br>  
          <input 
            class="w3-input w3-border" 
            type="text" 
            onFocus="this.select()"
            onClick="this.select()"
            v-if="pesquisa_orcamento_tipo_vendedor =='NO'" 
            v-model="pesquisa_orcamento_vendedor" 
            placeholder="Nome do vendedor"
          />
          <input 
            class="w3-input w3-border" 
            type="number" 
            onFocus="this.select()"
            onClick="this.select()"
            v-if="pesquisa_orcamento_tipo_vendedor =='ID'" 
            v-model="pesquisa_orcamento_vendedor" 
            placeholder="Código do vendedor"
          />
        </div>
            
      </div>
        
      <div class="w3-col s12 m12 s12 w3-center" style="margin-top: 20px;" v-show="somenteUltimosPedidosVendedor == 'N'">
        <button 
          class="w3-bar-item w3-button w3-white w3-border w3-block w3-mobile" 
          v-if="mostrar_filtros_orcamento == false" 
          v-on:click="mostrar_filtros_orcamento = !mostrar_filtros_orcamento">
          <i class="fa fa-filter icone-vermelho"/> Mostrar filtros
        </button>
              
        <button
          class="w3-button w3-theme"
          v-on:click="buscarOrcamento()"
          v-if="mostrar_filtros_orcamento"
          :disabled="processando">
          <i class="fa fa-search"/>
          <span>Pesquisar</span>
        </button>
          
        <br>
        <i 
          v-if="orcamentos_filtrados.length > 0 && mostrar_filtros_orcamento && !processando" 
          @click="mostrar_filtros_orcamento = false" 
          class='fas fa-caret-down' 
          style='font-size:24px; cursor: pointer;'
        />
      </div>

      <div class="w3-row-padding" style="padding:0px!important">
        <div 
          :key="index"
          class="w3-show card-item w3-border w3-container" 
          v-for="(orcamento, index) in orcamentos_filtrados"> 

          <div class="w3-col s12">
            <legenda v-if="orcamento.pedido_fechado == 'S'">
              <span>Pedido fechado</span>
              <i slot="referencia" class="fa fa-handshake w3-text-green"></i>
            </legenda>
          </div>

          <div @click="alternarDetalhes(index)">

            <strong
              class="texto-vermelho titulo" 
              style="font-size: 15px !important; color: w3-theme">
              {{orcamento.cadastro_id}} - {{orcamento.nome_cliente}}
            </strong>
          
            <div class="w3-col s12">
              <label>Código: </label>
              <strong>{{orcamento.orcamento_id}}</strong>
            </div>

            <div class="w3-col s12">
              <label>Data de cadastro: </label>
              <strong>{{orcamento.data_cadastro}}</strong>
            </div>

            <div class="w3-col s12">
              <label>Total do pedido: </label>
              <strong>{{orcamento.total_pedido}}</strong>
            </div>

            <div class="w3-col s12 w3-center" v-show="!orcamento.mostrar_detalhes">
              <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"></i>  
            </div> 
          </div> 

          <div v-show="orcamento.mostrar_detalhes" @click="alternarDetalhes(index)">
            <div class="w3-col s12">
              <label>Condição pag: </label>
              <strong>{{orcamento.condicao_id}} - {{orcamento.nome_condicao}}</strong>
            </div>

            <div class="w3-col s12">
              <label>Vendedor: </label>
              <strong>{{orcamento.vendedor_id}} - {{orcamento.nome_vendedor}}</strong>
            </div>                    
                
            <div class="w3-col s12" v-if="npz(orcamento.valor_produtos)">
              <label>Valor de produtos: </label>
              <strong>{{orcamento.valor_produtos}}</strong>
            </div>                  
            
            <div class="w3-col s12" v-if="npz(orcamento.valor_ipi)">
              <label>Valor de IPI: </label>
              <strong>{{orcamento.valor_ipi}}</strong>
            </div>                  

            <div class="w3-col s12" v-if="npz(orcamento.valor_subst_trib)">
              <label>Valor de ST: </label>
              <strong>{{orcamento.valor_subst_trib}}</strong>
            </div>

            <div class="w3-col s12 w3-center">
              <div
                class="opcoes">
                <button
                  title="Editar orçamento"
                  :disabled="orcamento.pedido_fechado == 'S'"
                  class="w3-button cor-botao-editar-pedido estilo-botao"
                  v-on:click="adicionarOrcamento(orcamento.orcamento_id)">
                  <i class="fa fa-pencil-alt"/>
                </button>
              </div>
            </div>

          </div>

          <div v-show="orcamento.mostrar_detalhes"> 
            <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
              <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;"></div>
              <h6>
                &nbsp;<i class="fas fa-list-ul"/>&nbsp;
                <strong> Opções </strong> 
              </h6>
              <div style="border-bottom: 2px dotted #a3a3a3;"></div>
            </div>

            <div
              class="w3-col s3 w3-center opcoes">
              <button
                title="Visualizar dados do pedido"
                v-on:click="abrirDadosPedido(orcamento.orcamento_id)"
                class="w3-button cor-botao-visualizar-pedido estilo-botao">
                <i class="fa fa-search"/>
              </button>
            </div>

            <div
              class="w3-col s3 w3-center opcoes">
              <button
                title="Copiar pedido"
                v-on:click="copiarPedido(orcamento.orcamento_id)"
                class="w3-button cor-botao-copiar estilo-botao">
                <i class="fa fa-copy"/>
              </button>
            </div>

            <div
              class="w3-col s3 w3-center opcoes">
              <button
                title="Visualizar mix do pedido"
                v-on:click="abrirDadosMix(orcamento.orcamento_id)"
                class="w3-button cor-botao-visualizar-mix estilo-botao">
                <i class="fa fa-chart-pie"/>
              </button>
            </div>

            <div
              class="w3-col s3 w3-center opcoes">
              <button
                title="Imprimir proposta"
                :disabled="orcamento.pedido_fechado == 'S'"
                class="w3-button cor-botao-imprimir-proposta estilo-botao"
                v-on:click="imprimirPropostaOrcamento(orcamento.orcamento_id)">
                <i class="fa fa-print"/>
              </button>
            </div>

          </div>

        </div> 
        

        <dados-orcamento
          v-if="mostrar_dados_orcamento"
          :orcamento_dados="dados_orcamento"
          @close="mostrar_dados_orcamento = false"
        />

        <modal-mix 
          :mix="mix" 
          v-if="mostrar_mix" 
          @close="mostrar_mix = false"
        />

        <modal-impressao-proposta-orcamento
          ref="modalImpressaoPropostaOrcamento"
          :recarregarTela="'N'"
          :orcamentoId="orcamento_id"
          :parEmpGerarBloqPropostaOrcamento="par_emp_gerar_bloq_proposta_orcamento"
          :telaOrigemImpressaoProposta="'PESQUISA_ORCAMENTOS'"
        />

      </div>
    </div>
  </div>
  
</template> 

<script>

import moment from 'moment'
import store from '@/ambiente/store'
import legenda from '@/components/Legendas'
import ModalMix from '@/components/ModalMix'
import RSessao from '@/components/Rest/RSessao'
import RBuscarMix from '@/components/Rest/RBuscarMix.js'
import formatarValorMixin from '@/mixins/formatarValorMixin'
import ExibirProcessando from '@/components/ExibirProcessando'
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import DadosOrcamento from '@/components/Orcamentos/DadosOrcamento'
import ModalImpressaoPropostaOrcamento from '@/components/Orcamentos/ModalImpressaoPropostaOrcamento'
import ROrcamentoPesquisarOrcamentos from '@/components/Rest/ROrcamento/ROrcamentoPesquisarOrcamentos.js'

export default {
  name: 'PesquisaOrcamentos',

  components: {
    legenda,
    ModalMix,
    DadosOrcamento,
    ExibirProcessando,
    ModalImpressaoPropostaOrcamento,
  },

  mixins:[formatarValorMixin],

  props:{
    somenteUltimosPedidosVendedor: {
      required: false,
      type: String,
      default: 'N'
    },

    carregarOrcamentoEdicao: {
      required: false,
      type: Function,
      default: undefined
    },
  },

  data () {
    return {
      api: process.env.API,
      /* Orçamento */
      orcamento_id: 0,
      orcamentos_filtrados: [],
      orcamentos_filtrados_aux: [],
      
      /* Pesquisa de orçamentos */
      pesquisa_orcamento_orcamento_id: '',
      pesquisa_orcamento_nome_cliente: '',
      pesquisa_orcamento_tipo_pessoa: '',
      pesquisa_orcamento_cnpj: '',
      pesquisa_orcamento_cpf: '',
      pesquisa_orcamento_data_cadastro_inicial: '',
      pesquisa_orcamento_data_cadastro_final: '',
      pesquisa_orcamento_tipo_vendedor: 'ID',
      pesquisa_orcamento_vendedor: '',
        
      processando: false,
        
      /*Variáveis para ocultar filtros*/
      mostrar_filtros_orcamento: true,        
      mostrar_filtros_vendedor: true,
      mostrar_filtros_condicao_pagamento: true,
        
      visivel: false,

      /* Preenchimento de orçamento */
      orcamento_dados_edicao: {},
      carregando_pedido: false,
      adicionando_direto: false,
      cliente_orc_pesquisado_cons_final: false,
      carregando_vendedor: false,

      visualizar_opcoes_orcamento: false,
      mix: {},
      autorizado_visualizar_mix: false,
      autorizado_visualizar_lucratividade_mix: false,
      autorizado_visualizar_lucro_liquido_mix: false,

      /* Dados do orçamento */
      dados_orcamento: undefined,
      mostrar_dados_orcamento: false,

      /* Mix */
      mix: {},
      mostrar_mix: false,
      perc_descontos_produtos_temp: [],

      /* Parâmetros*/
      par_emp_gerar_bloq_proposta_orcamento: '',
      autorizado_copiar_pedidos_venda: false,
      nome_vendedor: ''
    }
  },
  
  methods: {
    async abrirPesquisa(){
      // Buscando últimos pedidos
      if (this.somenteUltimosPedidosVendedor == 'S'){
        let retorno = await this.buscarOrcamento();

        if (retorno){
          this.visivel = true;  
        }
      } else {
        this.visivel = true;
        this.$nextTick(() => this.$refs.chave_orcamento.focus());
      }
    },

    async buscarDadosIniciais(){
      let buscou_dados_sessao = await RSessao.carregouSessao();
        
      if (!buscou_dados_sessao){
        await RSessao.buscarDadosCarregarSessao(this.axios);         
      }

      this.par_emp_gerar_bloq_proposta_orcamento = await store.state.parametros_empresa.gerar_bloq_proposta_orcamento;
      this.nome_vendedor = await store.state.usuario_logado.nome;
      this.autorizado_copiar_pedidos_venda = await RSessao.autorizado('copiar_pedidos_venda');
    },

    adicionarOrcamento(orcamento_id){

      if (this.carregarOrcamentoEdicao){
        this.carregarOrcamentoEdicao(orcamento_id, 'N');
        this.visivel = false;
      } else {
        this.acessarRouterOrcamentos(orcamento_id, 'N');
      }
    },

    copiarPedido(orcamento_id){
      if (!this.autorizado_copiar_pedidos_venda){
        swal("Usuário não autorizado a copiar pedidos de venda!");
        return;
      }

      if (this.carregarOrcamentoEdicao){
        this.carregarOrcamentoEdicao(orcamento_id, 'S');
        this.visivel = false;
      } else {
        this.acessarRouterOrcamentos(orcamento_id, 'S');
      }
    },

    acessarRouterOrcamentos(orcamento_id, copiando_pedido){
      let orcamento = {
        orcamento_id: orcamento_id,
        copiando_pedido: copiando_pedido
      }

      this.$router.push(
        {
          path: '/vendas/orcamentos', 
          query: { 
            orcamento: orcamento
          }
        }
      );
    },

    abrirDadosPedido(orcamento_id) {
      this.dados_orcamento = Biblioteca.valorInt(orcamento_id);
      this.mostrar_dados_orcamento = true;
    },

    async abrirDadosMix(orcamento_id){
      try {

        let parametros = {
          orcamento_id: orcamento_id
        }

        let retorno = await RBuscarMix.buscarMix(this.axios, parametros);

        if (retorno.houve_erro == 'S') {
          throw new Error(retorno.mensagem);
        }

        this.mix = retorno.dados;
        this.mostrar_mix = true;
      } catch (error) {
        this.verificarErro(error, 'buscarMix');
      }
    }, 

    async imprimirPropostaOrcamento(orcamento_id){
      await this.$refs.modalImpressaoPropostaOrcamento.abrir(orcamento_id);
    },

    alternarDetalhes(index){
      this.orcamentos_filtrados[index].mostrar_detalhes = this.orcamentos_filtrados[index].mostrar_detalhes ? false : true;
      this.$forceUpdate();
    },

    aplicarDataAtual(campo){
      if (campo == 'data_inicial'){
        this.pesquisa_orcamento_data_cadastro_inicial = this.dateToString(new Date().getDate().toString(),(new Date().getMonth() + 1).toString(),new Date().getFullYear().toString());
      } else if (campo == 'data_final'){
        this.pesquisa_orcamento_data_cadastro_final = this.dateToString(new Date().getDate().toString(), (new Date().getMonth() + 1).toString(),new Date().getFullYear().toString());
      }
    },

    dateToString(dia, mes, ano) {
      return ano + "-" + mes.padStart(2, "0") + "-" + dia.padStart(2, "0");
    },

    verificarErro(erro, nome_funcao){
      this.processando = false;
      this.orcamentos_filtrados = [];
      Biblioteca.gerarLogNomeFuncao('PesquisaOrcamentos.vue -> ' + nome_funcao);
      let mensagem = Biblioteca.tratamentoMensagem(erro);
      Biblioteca.exclamar(mensagem);
    },

    async buscarOrcamento(){ 
      let existe_resultados = false; 

      try { 
        if (this.somenteUltimosPedidosVendedor != 'S'){
          if 
            (
              ((this.pesquisa_orcamento_data_cadastro_inicial != '') &&
              (this.pesquisa_orcamento_data_cadastro_final == '')) ||
              ((this.pesquisa_orcamento_data_cadastro_inicial == '') && 
              (this.pesquisa_orcamento_data_cadastro_final != ''))
            ) 
          {
            Biblioteca.exclamar('Para realizar a pesquisa pela data de cadastro, é necessário preencher a data inicial e a data final!');
            return;
          }

          if (Biblioteca.valorInt(this.pesquisa_orcamento_orcamento_id) < 0) {
            Biblioteca.exclamar('Digite um código válido!');
            return;
          }

          if (this.pesquisa_orcamento_tipo_vendedor =='ID' && Biblioteca.valorInt(this.pesquisa_orcamento_vendedor) < 0) {
            Biblioteca.exclamar('Digite um código de vendedor válido!');
            return;
          }

          var parametro_cpf_cnpj = '';
          if (this.pesquisa_orcamento_tipo_pessoa == 'F') {
            parametro_cpf_cnpj = this.pesquisa_orcamento_cpf;
          }
          else {
            parametro_cpf_cnpj = this.pesquisa_orcamento_cnpj;
          }

          if 
            (
              parametro_cpf_cnpj == '' && 
              this.pesquisa_orcamento_orcamento_id == '' && 
              this.pesquisa_orcamento_data_cadastro_inicial == '' && 
              this.pesquisa_orcamento_data_cadastro_inicial == '' &&
              this.pesquisa_orcamento_vendedor == '' &&
              this.pesquisa_orcamento_nome_cliente == ''
            )
          {
            Biblioteca.exclamar('É necessário informar pelo menos 1 filtro!')
            return
          }
        }

        this.processando = true;
        this.orcamentos_filtrados = [];
        this.orcamentos_filtrados_aux = [];

        let parametros = {
          orcamento_id: this.pesquisa_orcamento_orcamento_id,
          cpf_cnpj: parametro_cpf_cnpj,
          tipo_pessoa: this.pesquisa_orcamento_tipo_pessoa,
          nome_cliente: this.pesquisa_orcamento_nome_cliente,
          data_cadastro_inicial: moment(this.pesquisa_orcamento_data_cadastro_inicial, 'YYYY/MM/DD').format('DD/MM/YYYY'),
          data_cadastro_final: moment(this.pesquisa_orcamento_data_cadastro_final, 'YYYY/MM/DD').format('DD/MM/YYYY'),
          tipo_filtro_vendedor: this.pesquisa_orcamento_tipo_vendedor,
          filtro_vendedor: this.pesquisa_orcamento_vendedor.toUpperCase(),
          somente_ultimos_pedidos_vendedor: this.somenteUltimosPedidosVendedor
        }

        let retorno = await ROrcamentoPesquisarOrcamentos.pesquisarOrcamentos(this.axios, parametros);

        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.processando = false;
        this.mostrar_filtros_orcamento = false;
        this.orcamentos_filtrados = JSON.parse(JSON.stringify(retorno.dados));

        if (this.somenteUltimosPedidosVendedor == 'S'){
          this.orcamentos_filtrados_aux = JSON.parse(JSON.stringify(retorno.dados));
        }

        existe_resultados = true;
      } catch (error) {
        this.verificarErro(error, 'buscarOrcamento'); 
        existe_resultados = false;
      } 

      return existe_resultados;
    },

    limparPesquisaPorNomeCliente(){
      document.getElementById("txtPesquisaCliente").value = '';
      this.pesquisarPorNomeCliente();
    },

    async pesquisarPorNomeCliente(){
      document.getElementById("txtPesquisaCliente").value = document.getElementById("txtPesquisaCliente").value.toUpperCase();
      let chave_pesquisa = document.getElementById("txtPesquisaCliente").value;
      this.orcamentos_filtrados = [];

      if (chave_pesquisa == '') {
        for (let i = 0; i < this.orcamentos_filtrados_aux.length; i++){
          this.orcamentos_filtrados.push(this.orcamentos_filtrados_aux[i]);
        }

        return;
      }

      for (let i = 0; i < this.orcamentos_filtrados_aux.length; i++){
        if (this.orcamentos_filtrados_aux[i].nome_cliente.indexOf(chave_pesquisa) != -1){
          this.orcamentos_filtrados.push(this.orcamentos_filtrados_aux[i]);
        }
      }
    },
  },

  async created() {
    await this.buscarDadosIniciais();
  },
}
</script>

<style escoped>

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    cursor: pointer;
  }

  .opcoes {
    padding-top: 5px; 
    padding-bottom: 5px;
  }

  .estilo-botao {
    width:50px; 
    font-weight: normal!important;
  }

  .cor-botao-editar-pedido {
    color: white;
    background-color: #b84d4d;
  }

  .cor-botao-visualizar-pedido {
    color: white;
    background-color: #cc942b;
  }

  .cor-botao-visualizar-mix {
    color: white;
    background-color: #5e66aa;
  }

  .cor-botao-imprimir-proposta {
    color: white;
    background-color: #804f6c;
  }

  .cor-botao-copiar {
    color: white;
    background-color: #83aa5e;
  }

  .input-pesquisa {
    border-radius: 10px;
    outline:none;
    border: 2px solid #ccc;
    padding-left: 15px;
    width: 98%; 
    font-size:14px;
  }

  .input-pesquisa:focus {
    border: 1px solid #bfbfbf;
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }

  .botao-pesquisa {
    border: 0px;
    margin-bottom: 5px;
    border-radius: 15px;
    height: 30px;
    width: 30px;
    color: #6e6e6e;
    background-color: white;
    margin-left: -50px;
  }

  .botao-pesquisa:focus {
    background-color: white;
    outline:none;
    color: #2193F6;
  }

</style>


// WEBPACK FOOTER //
// src/components/Pesquisas/PesquisaOrcamentos.vue